var s = Object.defineProperty;
var r = (t, i, n) => i in t ? s(t, i, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[i] = n;
var e = (t, i, n) => (r(t, typeof i != "symbol" ? i + "" : i, n), n);
function l() {
  let t = "frontiersin.org";
  if (typeof window < "u")
    if (location.host.indexOf(".") > -1) {
      const i = location.host.split(".");
      t = `${i[1]}.${i[2]}`;
    } else
      t = location.host;
  return t;
}
function a() {
  let t = null;
  if (typeof window > "u")
    return t;
  const i = window && window.location && window.location.host;
  if (!i)
    return t;
  const n = i.includes("frontiersin.org"), o = i.includes("fuat") || i.includes("test");
  return n ? t = "loop.frontiersin.org" : o ? t = "loop.test-frontiersin.net" : t = "loop.frontiers-ss-int.info", t;
}
class f {
  constructor() {
    e(this, "isInitialized", !1);
    e(this, "isFrontiers", !0);
    e(this, "tenantName", "Frontiers");
    e(this, "mainDomain", "");
    e(this, "ssMainDomain", "");
    e(this, "loopUrl", "");
    e(this, "useWwwAbsoluteUrls", !0);
  }
  get getIsInitialized() {
    return this.isInitialized;
  }
  get getIsFrontiers() {
    return this.getIsInitialized || console.warn(
      "Initialize $frontiersClibConfig by calling setConfig before calling getIsFrontiers"
    ), this.isFrontiers;
  }
  get getTenantName() {
    return this.getIsInitialized || console.warn(
      "Initialize $frontiersClibConfig by calling setConfig before calling getTenantName"
    ), this.tenantName;
  }
  get getMainDomain() {
    return this.getIsInitialized || (console.warn(
      "Initialize $frontiersClibConfig by calling setConfig before getting mainDomain, otherwise mainDomain will be obtained from the getLocationMainDomain helper"
    ), this.mainDomain = l()), this.mainDomain;
  }
  get getSsMainDomain() {
    return this.getIsInitialized || console.error(
      "Initialize $frontiersClibConfig by calling setConfig and pass ssMainDomain"
    ), this.ssMainDomain;
  }
  get getLoopUrl() {
    return this.getIsInitialized || (console.warn(
      "Initialize $frontiersClibConfig by calling setConfig before getting loopUrl, otherwise loopUrl will be obtained from the getLoopHost helper"
    ), this.loopUrl = `https://${a()}`), this.loopUrl;
  }
  setConfig(i) {
    this.isInitialized = !0, this.isFrontiers = i.isFrontiers, this.tenantName = i.tenantName, this.mainDomain = i.mainDomain, this.loopUrl = i.loopUrl, this.ssMainDomain = i.ssMainDomain, typeof i.useWwwAbsoluteUrls == "boolean" && (this.useWwwAbsoluteUrls = i.useWwwAbsoluteUrls);
  }
  /**
   *
   * @param url If it's relative it will complete the URL with the main-domain if the useWwwAbsoluteUrls config prop is enabled
   * @returns
   */
  getWwwAbsoluteUrl(i) {
    return i ? this.useWwwAbsoluteUrls && i.startsWith("/") ? `//www.${this.mainDomain}${i}` : i : (console.warn("url undefined"), "");
  }
}
const h = new f();
export {
  h as $
};
